<template>
  <div>
    <EmptyCart v-if="cart_count == 0" />
    <div v-else class="container">
      <div class="cart-panel">
        <!-- //panel heading
                <div class="panel-head">
                    <div class="d-flex">
                        <div class="col-md-7">
                            <div class="item_title">{{ $t("cart.itemname") }}</div>
                        </div>
                        <div class="col-md-2">
                            <div class="quantity_title">{{ $t("cart.quantity") }}</div>
                        </div>
                        <div class="col-md-2">
                            <div class="u_price_title">{{ $t("cart.unitprice") }}</div>
                        </div>
                        <div class="col-md-1">
                            <div class="action_title"> </div>
                        </div>
                    </div>
                </div>
          -->
        <div class="panel-body">
          <div
            v-for="product of cart.items"
            :key="product.id"
            class="row align-items-center"
          >
            <div class="col-md-6 col-sm-12">
              <div class="d-flex align-items-center">
                <div class="item_image">
                  <img :src="product.image_urls['100x100']" alt />
                </div>
                <div class="item_name">
                  <h4>{{ product.name }}</h4>
                  <p v-html="product.description" />
                </div>
              </div>
            </div>
            <div class="col-md-2 offset-md-1 col-sm-4 col-4">
              <div
                v-if="product.quantities_enable"
                data-quantity="Quantity"
                class="quantity"
              >
                <div class="input-group spinner">
                  <input
                    :value="product.quantity"
                    type="text"
                    class="form-control"
                  />
                  <div class="input-group-btn-vertical">
                    <button
                      class="btn btn-deafult"
                      type="button"
                      @click="incrementItemQuantity(product.id)"
                    >
                      <i class="far fa-angle-up"></i>
                    </button>
                    <button
                      class="btn btn-deafult"
                      type="button"
                      @click="decrementItemQuantity(product.id)"
                    >
                      <i class="far fa-angle-down"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-sm-4 col-4">
              <ItemPrice :price="product.price" :currency="currency" />
            </div>
            <div class="col-md-1 col-sm-4 col-4">
              <div data-action="Action" class="action">
                <button
                  class="btn btn-sm"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Remove"
                  @click="removeFromCart(product.id)"
                >
                  <i class="fad fa-lg fa-trash-alt"></i>
                </button>
              </div>
            </div>
          </div>

          <div
            class="row cart-total align-items-center justify-content-end"
            v-if="requires.coupon_field"
          >
            <div class="col-md-4">
              <ValidationObserver v-slot="{ coupon_invalid }">
                <form class="cupon" id="form-coupon">
                  <ValidationProvider rules="min:1" tag="div">
                    <div class="input-group">
                      <input
                        v-model="coupon"
                        type="text"
                        class="form-control"
                        :placeholder="$t('cart.coupon')"
                        aria-label="Coupon"
                        aria-describedby="basic-addon2"
                      />
                      <div class="input-group-append">
                        <button
                          :disabled="coupon_invalid"
                          class="btn"
                          type="button"
                          id="btn-apply-coupon"
                          @click="applyCoupon"
                        >
                          {{ $t("cart.apply") }}
                        </button>
                      </div>
                    </div>
                  </ValidationProvider>
                </form>
              </ValidationObserver>
              <!-- End of coupon form -->
            </div>
            <div class="col-md-4">
              <div class="total-price-info">
                <div v-if="discounts.length > 0" class="total-price-info">
                  <h6 class="coupon">
                    {{ $t("cart.coupon") }}:
                    <span v-for="discount of discounts" :key="discount.code">
                      {{ discount.name }} <code>({{ discount.code }})</code>
                      <br />
                    </span>
                  </h6>
                </div>
                <div v-if="cart.discount !== 0" class="total-price-info">
                  <h6 class="coupon">
                    {{ $t("cart.discount") }}:
                    {{ cart.discount | money(currency) }}
                  </h6>
                </div>
                <h4>
                  {{ $t("cart.totalprice") }}:
                  {{ cart.total | money(currency) }}
                </h4>
                <!-- <p>Includes: $6.12 VAT (15% of $39.74)</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-row row justify-content-between">
        <div class="col">
          <a
            @click="onContinueClick"
            :href="continue_shopping_url"
            class="btn btn-deafult"
            target="_top"
          >
            <fa-icon :icon="['far', 'arrow-left']" />
            {{ $t("cart.continueshopping") }}
          </a>
        </div>
        <div class="col">
          <router-link
            class="btn btn-primary next"
            name="next"
            value="Next"
            to="checkout"
          >
            {{ $t("cart.checkout") }}
            <fa-icon :icon="['far', 'arrow-right']" />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { get } from "vuex-pathify";

import EmptyCart from "@/components/cart/EmptyCart";
import ItemPrice from "@/components/cart/ItemPrice";

export default {
  components: {
    EmptyCart,
    ItemPrice,
  },
  data() {
    return {
      coupon: null,
    };
  },
  computed: {
    ...mapState({
      cart: (state) => state.cart || {},
      customer: (state) => state.customer || {},
      currency: (state) => state.currency,
      cart_count: (state) => state.cart.items.length,
      discounts: (state) => state.discounts,
      requires: (state) => state.requires,
    }),
    continue_shopping_url: get("continue_shopping_url"),
  },
  methods: {
    removeFromCart(id) {
      this.$store.dispatch("removeProduct", id);
    },
    incrementItemQuantity(id) {
      this.$store.dispatch("incrementItemQuantity", id);
    },
    decrementItemQuantity(id) {
      this.$store.dispatch("decrementItemQuantity", id);
    },
    applyCoupon() {
      if (this.coupon) {
        this.$store
          .dispatch("applyCoupon", this.coupon)
          .then(() => (this.coupon = null));
      }
    },
    onContinueClick: function (event) {
      if (this.isIframe) {
        event.preventDefault();
        window.postMessage("triggerCloseDPDLightbox", "*");
      }
    },
  },
};
</script>
